import { CldImage } from "next-cloudinary";
import SectionTitle from "components/typography/SectionTitle/SectionTitle";
import styles from "./OurStory.module.scss";
import Markdown from "markdown-to-jsx";

const OurStory = ({ about }) => {
  const text = about?.ourStoryTextPart1 + about?.ourStoryTextPart2;

  return (
    <div className={`${styles.ourStory} variable-container`} id="our-story">
      <h2 className={`${styles.sectionTitle}`}>
        <SectionTitle title="Our Story" />
      </h2>
      <div className={`${styles.container}`}>
        <CldImage
          src={about?.ourStoryImage?.data?.attributes?.url}
          alt={about?.ourStoryImageAlt ?? "Our story image"}
          width="515"
          height="655"
          loading="lazy"
          className={`${styles.imageWrapper}`}
        />
        <Markdown
          options={{ forceInline: true, wrapper: "span" }}
          className={`${styles.text1}`}
        >
          {about?.ourStoryTextPart1}
        </Markdown>
        <Markdown options={{ forceInline: true, wrapper: "span" }}>
          {about?.ourStoryTextPart2}
        </Markdown>
      </div>
      <div style={{ clear: "both" }}></div>
    </div>
  );
};

export default OurStory;
